import BaseDataObject from './BaseDataObject';
import TrendReduction from './TrendReduction';

export default class TrendReductionSet extends BaseDataObject {
  constructor() {
    super(...arguments);
    if (this.getNumberOfTrendReductions() === 0) {
      this.addTrendReduction();
      this.validate();
    }
  }

  getNumberOfTrendReductions() {
    return this.getNumberOf('trendReduction');
  }

  getTrendReduction(index) {
    return this.getObject('trendReduction', TrendReduction, index);
  }

  getAllTrendReduction() {
    return this.getObjects('trendReduction', TrendReduction);
  }

  addTrendReduction(data) {
    this.invalidate();
    return this.addObject('trendReduction', TrendReduction, data);
  }

  deleteTrendReduction(index) {
    this.invalidate();
    this.deleteObject('trendReduction', index);

    if (this.getNumberOfTrendReductions() === 0) {
      this.addTrendReduction();
    }
  }

  getMaxNumberOfTrendReductions() {
    return 2;
  }
}
